module.exports = __webpack_public_path__ + "img/39_60.7046dff8.png";